export enum RecaptchaAction {
    SignUp = 'signUp',
    Login = 'login',
    ResetPassword = 'resetPassword'
}